/* Schritt-Bestätigung: grüner Haken in der Überschrift, weiter zum nächsten Punkt */
(function(){
if(!document.getElementById('buyform'))return;
var style=document.createElement('style');
style.textContent='.acc-check{display:none;width:20px;height:20px;border-radius:999px;background:#1F9D5B;color:#fff;font-size:12px;font-weight:700;align-items:center;justify-content:center;margin-left:6px;flex:none}.acc-check.on{display:inline-flex}.acc-confirm{width:100%;margin-top:12px;padding:12px;border-radius:8px;border:2px solid #BF0C12;background:#fff;color:#BF0C12;font-family:Poppins,sans-serif;font-weight:700;font-size:14px;cursor:pointer;transition:.15s}.acc-confirm.on{background:#1F9D5B;border-color:#1F9D5B;color:#fff}.zs-edit{display:inline-flex;align-items:center;gap:4px;cursor:pointer;border-bottom:1px dashed #BF0C12}.zs-edit svg{opacity:.6}.zs-in{width:86px;height:30px;padding:0 8px;border:1.5px solid #BF0C12;border-radius:6px;font-family:Poppins,sans-serif;font-weight:700;font-size:14px;color:#BF0C12;text-align:right}#wt-mode{margin-left:6px;font-size:13px;color:#7C818A;font-weight:600;white-space:nowrap}@media(max-width:680px){#wt-mode{font-size:11px}}';
document.head.appendChild(style);
var accs=[].slice.call(document.querySelectorAll('.opt-acc'));
function ensureCheck(acc){var s=acc.querySelector('summary');var c=s.querySelector('.acc-check');if(!c){c=document.createElement('span');c.className='acc-check';c.textContent='\u2713';var arrow=s.querySelector('.acc-arrow');s.insertBefore(c,arrow)}return c}
accs.forEach(ensureCheck);
function setDone(acc,on){ensureCheck(acc).classList.toggle('on',!!on)}
function advance(acc){acc.removeAttribute('open');var i=accs.indexOf(acc);if(i>=0&&accs[i+1])accs[i+1].setAttribute('open','')}
function hook(btnId,isOn){
 var b=document.getElementById(btnId);if(!b)return;
 b.addEventListener('click',function(){var acc=b.closest('.opt-acc');var on=isOn();setDone(acc,on);if(on)advance(acc)});
}
hook('zs-confirm',function(){var x=document.getElementById('zuschnitt-on');return x&&x.checked});
hook('zs2-confirm',function(){var x=document.getElementById('zs2-on');return x&&x.checked});
hook('mt-confirm',function(){var x=document.getElementById('montage');return x&&x.checked});
/* Keine Montage: Checkbox unter dem Montage-Button – markiert den Schritt als erledigt und springt weiter */
(function(){
 var mtBtn=document.getElementById('mt-confirm');if(!mtBtn)return;
 var wrap=document.createElement('label');
 wrap.style.cssText='display:flex;align-items:center;gap:9px;margin:12px 2px 0;font-size:14px;color:#24262A;cursor:pointer;font-family:Figtree,sans-serif';
 wrap.innerHTML='<input type="checkbox" id="mt-none" style="width:18px;height:18px;accent-color:#BF0C12;flex:none;cursor:pointer"> Keine Montage gew\u00fcnscht \u2013 weiter ohne Montageservice';
 mtBtn.parentNode.insertBefore(wrap,mtBtn.nextSibling);
 var nn=wrap.querySelector('#mt-none');
 nn.addEventListener('change',function(){
  var acc=nn.closest('.opt-acc');
  if(nn.checked){
   var m=document.getElementById('montage');
   if(m&&m.checked){m.checked=false;m.dispatchEvent(new Event('change'));}
   mtBtn.textContent='Montage best\u00e4tigen';mtBtn.style.background='#fff';mtBtn.style.color='#BF0C12';
   setDone(acc,true);advance(acc);
  }else{
   setDone(acc,false);
  }
 });
 mtBtn.addEventListener('click',function(){
  var m=document.getElementById('montage');
  if(m&&m.checked&&nn.checked){nn.checked=false}
 });
})();
/* Bestätigungs-Button für Schritte ohne eigenen Button (Beleuchtung, Wunschtermin) */
[['led-vals','Beleuchtung best\u00e4tigen'],['cal','Termin best\u00e4tigen']].forEach(function(def){
 var el=document.getElementById(def[0]);if(!el)return;
 var acc=el.closest('.opt-acc');if(!acc||acc.querySelector('.acc-confirm'))return;
 var body=acc.querySelector('.acc-body');
 var b=document.createElement('button');b.type='button';b.className='acc-confirm';b.textContent=def[1];
 b.addEventListener('click',function(){
  var on=!b.classList.contains('on');
  if(def[0]==='cal'){
   var df=document.getElementById('datefield');
   if(on&&df&&!df.value){var free=document.querySelector('#cal .cal-d[data-d]');if(free)free.click()}
  }
  b.classList.toggle('on',on);
  b.textContent=on?'\u2713 Best\u00e4tigt \u2013 klicken zum \u00c4ndern':def[1];
  var acc2=b.closest('.opt-acc');setDone(acc2,on);if(on)advance(acc2);
 });
 body.appendChild(b);
});
/* Wunschtermin-Überschrift: (Lieferung) vs. (Lieferung + Montage) – rechts neben dem grünen Haken */
var calEl=document.getElementById('cal');
if(calEl){
 var acc4=calEl.closest('.opt-acc'),sum=acc4&&acc4.querySelector('summary'),tn=null;
 if(sum){[].slice.call(sum.childNodes).forEach(function(n){if(n.nodeType===3&&/Wunschtermin/.test(n.nodeValue))tn=n})}
 var mode=null;
 if(sum&&tn){
  tn.nodeValue=' Wunschtermin ';
  mode=document.createElement('span');mode.id='wt-mode';
  var chk4=ensureCheck(acc4);
  sum.insertBefore(mode,chk4.nextSibling);
 }
 var mEl=document.getElementById('montage');
 function updLabel(){if(mode)mode.textContent='('+(mEl&&mEl.checked?'Lieferung + Montage':'Lieferung')+')'}
 if(mEl)mEl.addEventListener('change',updLabel);
 updLabel();
}
/* Zuschnitt: Slider an Variantenauswahl koppeln + Wert per Klick selbst eintippen */
(function(){
 var zf=document.getElementById('zs-fields');if(!zf)return;
 var ranges=[].slice.call(zf.querySelectorAll('input[type=range]'));
 function mm(s){s=String(s).replace(',','.');var m=s.match(/([\d.]+)\s*Meter/i);if(m)return Math.round(parseFloat(m[1])*1000);var x=s.match(/(\d{3,5})\s*mm/i);if(x)return parseInt(x[1],10);return 0}
 function findRange(valId){for(var i=0;i<ranges.length;i++){if((ranges[i].getAttribute('oninput')||'').indexOf(valId)>=0)return ranges[i]}return null}
 function setVal(r,outId,valId,v){
  v=Math.max(parseInt(r.min,10),Math.min(parseInt(r.max,10),v));
  r.value=v;
  var out=document.getElementById(outId);if(out&&out.firstChild)out.firstChild.nodeValue=v+' mm';else if(out)out.textContent=v+' mm';
  var hid=document.getElementById(valId);if(hid)hid.value=v+' mm';
  document.dispatchEvent(new Event('tp:update'));
  return v;
 }
 /* Klick auf den roten Wert = selbst eintippen (optional) */
 function editable(r,outId,valId){
  var out=document.getElementById(outId);if(!out||!r)return;
  out.classList.add('zs-edit');out.title='Klicken und Wunschma\u00df eintippen';
  if(!out.querySelector('svg')){out.innerHTML=(out.textContent||'')+' <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3l4 4L8 20l-5 1 1-5z"></path></svg>'}
  out.addEventListener('click',function(){
   if(out.style.display==='none')return;
   var inp=document.createElement('input');inp.type='number';inp.className='zs-in';inp.min=r.min;inp.max=r.max;inp.step=r.step||10;inp.value=r.value;
   out.style.display='none';out.parentNode.insertBefore(inp,out.nextSibling);
   inp.focus();inp.select();
   function done(){var v=parseInt(inp.value,10);if(!isNaN(v))setVal(r,outId,valId,v);inp.remove();out.style.display=''}
   inp.addEventListener('blur',done);
   inp.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();inp.blur()}});
  });
  r.addEventListener('input',function(){if(out.firstChild)out.firstChild.nodeValue=r.value+' mm '});
 }
 function bind(optRegex,valId,outId){
  var sel=null;
  [].slice.call(document.querySelectorAll('.opt-vals[data-name]')).forEach(function(w){if(optRegex.test(w.getAttribute('data-name')||'')){var card=w.closest('.opt-card');sel=card&&card.querySelector('.opt-sel')}});
  var r=findRange(valId);if(!r)return;
  editable(r,outId,valId);
  if(!sel)return;
  function apply(){
   var opts=[].slice.call(sel.options).map(function(o){return mm(o.value)}).filter(function(v){return v>0});
   opts=opts.filter(function(v,i){return opts.indexOf(v)===i}).sort(function(a,b){return a-b});
   var cur=mm(sel.value);if(!cur)return;
   var lower=0;
   for(var i=0;i<opts.length;i++){if(opts[i]<cur&&opts[i]>lower)lower=opts[i]}
   if(!lower)lower=cur-500;
   r.min=lower;r.max=cur;
   var v=parseInt(r.value,10);if(isNaN(v)||v>cur||v<lower)v=cur;
   setVal(r,outId,valId,v);
   var wrap=r.parentElement;
   var spans=wrap.querySelectorAll('div span');
   if(spans.length>=2){spans[0].textContent='min: '+lower+' mm';spans[1].textContent='max: '+cur+' mm'}
  }
  sel.addEventListener('change',apply);
  apply();
 }
 bind(/reite/i,'zs-b-val','zs-b-out');
 bind(/iefe/i,'zs-t-val','zs-t-out');
 /* Höhe ebenfalls eintippbar */
 editable(findRange('zs-h-val'),'zs-h-out','zs-h-val');
})();
})();